var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeInUp","mode":"out-in"}},[_c('div',{staticClass:"settings_page_wrapper"},[_c('div',{staticClass:"nested_routes_wrapper"}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }